import { Button, HStack, Text } from '@chakra-ui/react'
import React from 'react'

interface ReportingPeriodSelectorProps {
  monthMoment: moment.Moment
  changeToMoment: moment.Moment
  pastDeadline: boolean
  onMonthChange: () => void
}

const ReportingPeriodSelector: React.FC<ReportingPeriodSelectorProps> = ({
  monthMoment,
  changeToMoment,
  pastDeadline,
  onMonthChange,
}) => {
  return (
    <HStack spacing={4}>
      <Text>Reporting for: {monthMoment.format('MMMM YYYY')}</Text>
      <Button variant='link' onClick={onMonthChange} isDisabled={pastDeadline}>
        Change to {changeToMoment.format('MMMM YYYY')}
        {pastDeadline ? ' (Past Deadline)' : ''}
      </Button>
    </HStack>
  )
}

export default ReportingPeriodSelector
